import { useState } from 'react';

import { isEmailAddress } from '@/helpers/validators';
import { useForm, UseFormReturnType } from '@mantine/form';

type FormValues = {
  email: string;
  accepted: boolean;
};

type UseSignUpEmail = () => {
  form: UseFormReturnType<FormValues>;
  next: boolean;
  back: () => void;
  onSubmit: () => void;
  canProceed: boolean;
};

const useSignUpEmail: UseSignUpEmail = () => {
  const form = useForm<FormValues>({
    initialValues: {
      email: '',
      accepted: false,
    },
    validate: {
      email: isEmailAddress('Invalid email'),
    },
  });
  const [next, setNext] = useState(false);

  const onSubmit = form.onSubmit(() => setNext(true));

  return {
    form,
    next,
    back: () => setNext(false),
    onSubmit,
    canProceed: !form.values.email || !form.values.accepted || next,
  };
};

export default useSignUpEmail;
